import { render, staticRenderFns } from "./header-right.vue?vue&type=template&id=1a2de56c&scoped=true"
import script from "./header-right.vue?vue&type=script&lang=js"
export * from "./header-right.vue?vue&type=script&lang=js"
import style0 from "./header-right.vue?vue&type=style&index=0&id=1a2de56c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2de56c",
  null
  
)

export default component.exports